import main from 'ui/styles/MaterialTheme/themes/main';

const themes = {
  main,
};

export default themes;
